var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Tribe Payments"),_c('br')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }